import React from "react";
import { img } from "../lib/api";

const BrandLogo = ({ settings, size = "h-11 w-11", testId = "brand-logo" }) =>
  settings?.logoImage ? (
    <img src={img(settings.logoImage)} alt={settings.brandName} data-testid={testId}
      className={`${size} rounded-full object-cover ring-1 ring-gold/40 shadow-lg shadow-gold/10`} />
  ) : (
    <div data-testid={testId}
      className={`${size} rounded-full bg-gradient-to-br from-gold-light to-gold-dark flex items-center justify-center text-navy font-display font-extrabold text-lg shadow-md`}>
      {settings?.logoText}
    </div>
  );

export default BrandLogo;
